module.exports = __webpack_public_path__ + "img/block-1-img.8661ede9.png";